<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="false"
                                id="ki"
                                size="lg"
                                title="Kantoorinstellingen">

  <snelstart-ui-dialog-header-content></snelstart-ui-dialog-header-content>

  <snelstart-ui-dialog-body [padding]="0">
    <snelstart-ui-tab>
      <snelstart-ui-tab-item
        (click)="onSelectTab(0)"
        [isActive]="this.selectedTab === 0"
        id="firstTab"
      >
        Algemeen
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(1)"
        [isActive]="this.selectedTab === 1"
        id="secondTab"
      >
        SnelStart Fiscaal
      </snelstart-ui-tab-item>
      <snelstart-ui-tab-item
        (click)="onSelectTab(2)"
        [isActive]="this.selectedTab === 2"
        id="thirdTab"
      >
        PKI-certificaat
      </snelstart-ui-tab-item>
    </snelstart-ui-tab>
    <snelstart-ui-tab-content>
      @if (selectedTab === 0) {
        <div [formGroup]="intermediaryFormGroup" class="pt-1">
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="me-1 custom-input-250"
                                          formControlName="officeName"
                                          id="officeName"
                                          label="Kantoornaam"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-email-form-control class="me-1 custom-input-250 "
                                           formControlName="officeEmail"
                                           id="officeEmail"
                                           label="E-mailadres"
          >
          </snelstart-ui-email-form-control>
        </div>
        <div [formGroup]="intermediaryDisplayFormGroup" class="pt-1">
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="me-1 custom-input-250"
                                          formControlName="sstPrimaryAdminName"
                                          id="sstPrimaryAdminId"
                                          label="SnelStart kantooradministratie"
          >
          </snelstart-ui-text-form-control>
        </div>
        <div [formGroup]="intermediaryFormGroup" class="pt-1">
          <snelstart-ui-text-form-control [disabledControl]="true"
                                          class="me-1 custom-input-250"
                                          formControlName="licenceName"
                                          id="licenceName"
                                          label="SnelStart pakket"
          >
          </snelstart-ui-text-form-control>
        </div>
      }
      @if (selectedTab === 1) {
        <div [formGroup]="intermediaryFormGroup" class="pt-1">
          <snelstart-ui-text-form-control [forceInvalidBorder]="!this.validateBeconnummer()"
                                          class="custom-input-250"
                                          formControlName="beconId"
                                          id="beconId"
                                          label="Beconnummer kantoor"
          >
          </snelstart-ui-text-form-control>
          <snelstart-ui-bsn-form-control class="custom-input-250"
                                         formControlName="taxId"
                                         id="taxId"
                                         label="RSIN/Fiscaal nummer kantoor"
          >
          </snelstart-ui-bsn-form-control>
          @if (this.intermediaryFormGroup.get('gemachtigdeId')?.value !== undefined) {
            <snelstart-ui-text-form-control [disabledControl]="true"
                                            class="custom-input-250"
                                            formControlName="gemachtigdeId"
                                            id="gemachtigdeId"
                                            label="Gemachtigde identiteitsnummer"
            >
            </snelstart-ui-text-form-control>
          }
        </div>
        <div class="pt-2">
          <snelstart-ui-alert [showIcon]="true" type="info">
            Met het invullen van het beconnummer, het RSIN/fiscaal nummer en een eigen
            PKIoverheid-certificaat (tabblad hiernaast) wordt de uitstelregeling automatisch beschikbaar. De
            uitstelregeling, ook wel bekend als 'Beconregeling',
            kan door een kantoor gebruikt worden, maar dat hoeft niet.
          </snelstart-ui-alert>
        </div>
      }
      @if (selectedTab === 2) {
        @if (this.intermediaryFormGroup.get('beconId')?.value === null || this.intermediaryFormGroup.get('beconId')?.value === '') {
          <div class="pt-1">
            <snelstart-ui-alert type="info">
              Let op! Om een eigen certificaat te kunnen uploaden dien je eerst bij het tabblad 'SnelStart
              Fiscaal' het beconnummer en RSIN/fiscaal nummer in te vullen.
            </snelstart-ui-alert>
          </div>
        } @else {
          @if (this.intermediaryFormGroup.get('hasBerichten')?.value !== null || this.intermediaryFormGroup.get('certValidUntil')?.value !== null) {
            <form [formGroup]="intermediaryFormGroup">
              <snelstart-ui-date-form-control [disabledControl]="true"
                                              class="custom-input-250"
                                              formControlName="certValidUntil"
                                              id="certValidUntil"
                                              label="Datum geldigheid huidig certificaat"
              >
              </snelstart-ui-date-form-control>
            </form>
            @if(stepperItems[2].state !== 'active') {
              <form [formGroup]="intermediaryFormGroup">
                <snelstart-ui-select-form-control [options]="optionsJaNeeSba"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="hasBerichten"
                                                  id="SBASBAT"
                                                  label="Ophalen serviceberichten (SBA/SBU/SBT/VIA)">
                </snelstart-ui-select-form-control>
              </form>
            }
          }

          @if (intermediaryFormGroup.get('certValidUntil')?.getRawValue() !== null) {
            <!--                        <div class="pt-1"></div>-->
              <!--                        <hr class="line-color">-->
            <div class="pt-2 pb-1">
              Installeer hieronder indien nodig een nieuw certificaat. Het nieuwe certificaat overschrijft het bestaande
              certificaat.
            </div>
          }

          <div class="pt-1">
            <snelstart-ui-stepper [items]="stepperItems" style="margin-bottom: 2em">
            </snelstart-ui-stepper>
            @if (stepperItems[0].state === 'active') {
              <div [formGroup]="pkiUpload">
                <snelstart-ui-text-form-control class="custom-input-250"
                                                formControlName="pkiPassword"
                                                id="pkiPassword"
                                                label="Certificaat wachtwoord"
                >
                </snelstart-ui-text-form-control>
              </div>
              <snelstart-ui-button (click)="activateStepperItems(1)"
                                   [disabled]="!pkiUpload.get('pkiPassword')?.value"
                                   class="custom-input-250 mb-2"
                                   icon="check"
                                   type="secondary">
                Bevestigen
              </snelstart-ui-button>
            }

            @if (stepperItems[1].state === 'active') {
              <form [formGroup]="pkiUpload" style="padding-bottom: 1em">
                <div>
                  <input #fileUpload (change)="onFileSelected($event)" accept=".p12,.pfx,.p7b"
                         class="file-input"
                         type="file">
                  <snelstart-ui-button (click)="fileUpload.click();"
                                       [disabled]="pkiUpload.get('pkiPassword')?.getRawValue() === undefined"
                                       class="upload-btn"
                                       icon="cloud-arrow-up"
                                       type="secondary"
                  >
                    Selecteer certificaat
                  </snelstart-ui-button>
                </div>
              </form>
              <div class="pt-2">
                <snelstart-ui-alert type="info">
                  Selecteer het certificaat in een .pem of een .pfx bestand. Meer informatie over
                  instellen machtigingen en ophalen berichten op ons <a
                  href="https://kennisplein.snelstart.nl/snelstartpolaris/machtigingen"
                  target="_blank">Kennisplein</a>
                </snelstart-ui-alert>
              </div>
            }
            @if (stepperItems[2].state === 'active') {
              <form [formGroup]="intermediaryFormGroup">
                <snelstart-ui-select-form-control [options]="optionsJaNeeSba"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="hasBerichten"
                                                  id="SBASBAT1"
                                                  label="Ophalen SBA's (zie ook kennisplein)">
                </snelstart-ui-select-form-control>
                <snelstart-ui-alert type="info">
                  Met een eigen PKI-certificaat kun je binnen SnelStart Fiscaal de machtigingen van
                  klanten
                  beheren en serviceberichten aanslagen, toeslagen (SBA/SBT), uitstel (SBU) en Vooraf
                  Ingevulde Aangifte (VIA) ontvangen. Met onderstaande keuze geef je aan of je hier
                  gebruik van wilt
                  maken. Meer informatie over instellen machtigingen en ophalen berichten op ons <a
                  href="https://kennisplein.snelstart.nl/snelstartpolaris/machtigingen"
                  target="_blank">Kennisplein</a>.
                </snelstart-ui-alert>
              </form>
            }
          </div>
        }
      }
    </snelstart-ui-tab-content>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons>
    <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                         type="secondary">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button (click)="this.postOneIntermediary(false)"
                         icon="check"
                         id="save"
                         type="primary">
      Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
